import React from 'react';
import BlankPage from '../../components/BlankPage';

const WorkRemotely = () => {
  return (
    <BlankPage 
      title="Work Remotely" 
      description="Request and manage remote work arrangements and schedules." 
    />
  );
};

export default WorkRemotely; 